<template>
    <div class="page">
        <div class="page_inner">
            <Schedule :type="config.type" :step="config.step" />
            <TypeSelector v-if="config.step == 1"  @next="toAuth" />
            <template v-if="config.step == 2">
                <QRCode v-if="authType  == 1" :type="0" @prev="config.step = 1; config.type = 1;" @next="thirdAuthSuccessHanlder"/>
                <QRCode v-if="authType  == 2" :type="1" @prev="config.step = 1; config.type = 1;" @next="thirdAuthSuccessHanlder"/>
                <PersonalInfo v-if="authType  == 3" @prev="config.step = 1; config.type = 1;" @next="updateState"  />
                <CompanyInfo v-if="authType  > 3" :type="authType" @prev="config.step = 1; config.type = 1;" @next="updateState"  />
            </template>
            <template v-if="config.step == 3">
                <Result v-if="config.type == 0" :isSuccess="userInformation.authStatus == 4" @restart="config.step = 1;" />
                <Pending v-if="config.type == 1" :type="authType"/>
            </template>
        </div>
    </div>
</template>

<script setup>
import { onMounted, reactive, ref, computed } from 'vue';
import Schedule from './Schedule.vue'
import TypeSelector from './TypeSelector.vue';
import QRCode from './QRCode.vue';
import PersonalInfo from './PersonalInfo.vue';
import CompanyInfo from './CompanyInfo.vue';
import Result from './Result.vue';
import Pending from './Pending.vue';
import { http } from '@/request/http';
import { useStore } from 'vuex'
const store = useStore()
const userInformation = computed(() => store.state.login.userInfo)
const config = reactive({
    type: 0,
    step: 1
})
const authType = ref(0)
const toAuth = type => {
    authType.value = type
    config.step = 2
    config.type = type > 1 ? 1 : 0
}

const thirdAuthSuccessHanlder = () => {
    updateState()
}

onMounted(() => {
    updateState()
})

function updateState(){
    http.get('/app-api/member/user/get').then(res => {
        store.commit('setUserInfo', res)
        if(res.authStatus == 4 || res.authStatus == 5){
            config.step = 3
            config.type = 0
        }
        if(res.authStatus == 2){
            config.type = 1
            config.step = 3
        }
    })
}
</script>

<style scoped lang="scss">
.page{
    width: 100%; display: flex; justify-content: center; min-height: calc(100vh - 60rem); background-color: #F7F7F9;
    .page_inner{
        width: 90%;
        :deep(.van-breadcrumb) {
            font-size: 14rem; padding: 20rem 0;
        }
    }
}
</style>
